export var searchParametersManager = {}

searchParametersManager.searchParameters = {}
